var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Kursmanager - Bewertungstabellen'),"lastPath":-1,"showDrawer":false}}),_c('GradingTables',{attrs:{"isAdmin":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }